import { useContext } from "react";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import { useTranslation } from "react-i18next";

import { GlobalContext } from "../../../context/GlobalContext";

import CaretRight from "../../../assets/CaretRight.svg";
import CaretLeft from "../../../assets/CaretLeft.svg";

export interface Props {
  rtl: boolean;
  selectedOrder: any;
}

const win: any = window;

function OrderListCard({ rtl, selectedOrder }: Props) {
  const sideCaret = rtl ? CaretLeft : CaretRight;
  const [, dispatch]: any = useContext(GlobalContext);
  const { t } = useTranslation();
  const dir = rtl ? "right" : "left";

  const handleClick = (values: any) => {
    dispatch({
      type: "TRACK_ORDER_NUMBER_DATA",
      // payload: { values, page: "Status" }
      payload: { values }
    });
    window.location = win['track_order_thanku_url']
  };

  const orderDate = selectedOrder.CDOC_CREATEDATE_LOCAL.split("/")[0];
  return (
    <div className="orderList-info" onClick={() => handleClick(selectedOrder)}>
      <div className="row">
        <>
          <div>
            <Typography className={`order-num arabicBold-${dir} `} rtl={rtl}>
              {t('Order')} {selectedOrder.CDOC_ID}
            </Typography>
            <Typography className="orderNo-date sansFont" rtl={rtl}>
              {orderDate}
            </Typography>
          </div>
          <img className='order-caretImg' src={sideCaret} alt="sidecaret" />
        </>
      </div>
    </div>
  );
}

export default OrderListCard;